/*
 * Lightweight Australian phone field: an area-code dropdown + number input.
 * Enhances any ".au-phone" group with [data-au-area] (select) and [data-au-phone] (input).
 * The visible input keeps the form field name; on submit it's rewritten to the full
 * national number (so it works even if JS only partially runs).
 */
(function () {
  const digits = (s) => (s || '').replace(/\D/g, '');

  function localDigits(input) {
    let d = digits(input.value);
    // strip a leading area code if a full national number was pasted (e.g. 0412 345 678)
    if (d.length > 8 && d[0] === '0') d = d.slice(2);
    return d.slice(0, 8);
  }

  function formatLocal(area, d) {
    d = (d || '').slice(0, 8);
    if (area === '04') return [d.slice(0, 2), d.slice(2, 5), d.slice(5, 8)].filter(Boolean).join(' ');
    return [d.slice(0, 4), d.slice(4, 8)].filter(Boolean).join(' ');
  }

  function national(area, d) {
    d = (d || '').slice(0, 8);
    if (!d) return '';
    if (area === '04') {
      const full = ('04' + d).slice(0, 10);
      return full.length === 10 ? full.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3') : full;
    }
    return d.length === 8 ? `(${area}) ${d.slice(0, 4)} ${d.slice(4)}` : `(${area}) ${d}`;
  }

  function wire(root) {
    const area = root.querySelector('[data-au-area]');
    const input = root.querySelector('[data-au-phone]');
    if (!area || !input || input.dataset.auWired) return;
    input.dataset.auWired = '1';

    const reformat = () => {
      input.value = formatLocal(area.value, localDigits(input));
    };
    input.addEventListener('input', reformat);
    area.addEventListener('change', reformat);

    const form = root.closest('form');
    if (form) {
      form.addEventListener('submit', () => {
        input.value = national(area.value, localDigits(input));
      });
    }
  }

  function init() {
    document.querySelectorAll('.au-phone').forEach(wire);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
